export enum PostableTypes {
    CHANNELS = "channels",
    COURSECONTENTS = "coursecontents",
}